import { render, staticRenderFns } from "./QuantityWarningDetailList.vue?vue&type=template&id=04a70a96&scoped=true"
import script from "./QuantityWarningDetailList.vue?vue&type=script&lang=js"
export * from "./QuantityWarningDetailList.vue?vue&type=script&lang=js"
import style0 from "./QuantityWarningDetailList.vue?vue&type=style&index=0&id=04a70a96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a70a96",
  null
  
)

export default component.exports